import React, { Component, Fragment } from "react";
// import { connect } from "react-redux";
// import { userLogout } from "../../../../redux/actions";

// Externals
import classNames from "classnames";
import PropTypes from "prop-types";

// Material helpers
import { withStyles } from "@material-ui/core";

// Material components
import {
  // Badge,
  IconButton,
  Popover,
  Toolbar,
  Typography
} from "@material-ui/core";

// Material icons
import {
  Menu as MenuIcon,
  Close as CloseIcon,
  // NotificationsOutlined as NotificationsIcon,
  Input as InputIcon
} from "@material-ui/icons";

// Shared services
import { getNotifications } from "services/notification";

// Custom components
import { NotificationList } from "./components";

// Component styles
import styles from "./styles";
//language
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import multilang from "../../../../language/lang.json";
import { Fetch } from "../../../../fetch/siteFetch";

class Topbar extends Component {
  signal = true;
  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
      notificationsLimit: 4,
      notificationsCount: 0,
      notificationsEl: null,
      anchorEl: null,
      loading: false
    };
  }

  async getNotifications() {
    try {
      const { notificationsLimit } = this.state;

      const { notifications, notificationsCount } = await getNotifications(
        notificationsLimit
      );

      if (this.signal) {
        this.setState({
          notifications,
          notificationsCount
        });
      }
    } catch (error) {
      return;
    }
  }

  componentDidMount() {
    this.signal = true;
    this.getNotifications();
  }

  componentWillUnmount() {
    this.signal = false;
  }

  handleSignOut = async () => {
    this.setState({ loading: true });
    const token = localStorage.getItem("token");
    try {
      await Fetch({
        body: "logOut",
        type: "GET",
        auth: token,
        api: "auth"
      });
      // console.log(resp);
      this.props.userLogout();
    } catch (err) {
      console.log(err);
    }
    this.setState({ loading: false });
  };

  handleShowNotifications = event => {
    this.setState({
      notificationsEl: event.currentTarget
    });
  };

  handleCloseNotifications = () => {
    this.setState({
      notificationsEl: null
    });
  };
  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  handelLanguage = ({ lang, dir, id }) => {
    const token = localStorage.getItem("token");
    this.props.changelang({ lang, dir, token, id });
  };
  render() {
    const {
      classes,
      className,
      title,
      isSidebarOpen,
      onToggleSidebar,
      language: { dir, lang },
      culture
    } = this.props;
    const {
      notifications,
      // notificationsCount,
      notificationsEl,
      anchorEl,
      loading
    } = this.state;

    const rootClassName = classNames(classes.root, className);
    const showNotifications = Boolean(notificationsEl);

    return (
      <Fragment>
        <div className={rootClassName}>
          <Toolbar
            className={dir === "rtl" ? classes.toolbar : classes.toolbarLtr}>
            <IconButton
              className={classes.menuButton}
              onClick={onToggleSidebar}
              variant="text">
              {isSidebarOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
            <Typography className={classes.title} variant="h4">
              {title}
            </Typography>
            {/* <IconButton
              className={classes.notificationsButton}
              onClick={this.handleShowNotifications}
            >
              <Badge
                badgeContent={notificationsCount}
                color="primary"
                variant="dot"
              >
                <NotificationsIcon />
              </Badge>
            </IconButton> */}
            <div
              className={
                dir === "ltr" ? classes.topBarlang : classes.topBarlangfa
              }>
              <IconButton
                className={classes.signOutButton}
                onClick={this.handleSignOut}
                disabled={loading}>
                <InputIcon />
              </IconButton>

              <Button
                aria-controls="simple-menu"
                aria-haspopup="true"
                onClick={e => this.setState({ anchorEl: e.currentTarget })}>
                {multilang["116"][lang]}
              </Button>
              <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={this.handleClose}>
                {JSON.parse(culture).map((row, i) => (
                  <MenuItem
                    key={i}
                    onClick={() => {
                      this.handelLanguage({
                        lang: row.language,
                        dir: row.direction,
                        id: row.id
                      });
                      this.handleClose();
                    }}
                    className={dir === "ltr" ? classes.lien : classes.lifa}>
                    {/* {console.log(row)} */}
                    {row.language === "fa"
                      ? multilang["118"][lang]
                      : multilang["117"][lang]}
                  </MenuItem>
                ))}
                {/* <MenuItem
                  onClick={() => {
                    this.handelLanguage({ lang: "fa", dir: "rtl" });
                    this.handleClose();
                  }}
                >
                  {multilang["118"][lang]}
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    this.handelLanguage({ lang: "en", dir: "ltr" });
                    this.handleClose();
                  }}
                >
                  {multilang["117"][lang]}
                </MenuItem> */}
              </Menu>
            </div>
          </Toolbar>
        </div>
        <Popover
          anchorEl={notificationsEl}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center"
          }}
          onClose={this.handleCloseNotifications}
          open={showNotifications}
          transformOrigin={{
            vertical: "top",
            horizontal: "center"
          }}>
          <NotificationList
            notifications={notifications}
            onSelect={this.handleCloseNotifications}
          />
        </Popover>
      </Fragment>
    );
  }
}

Topbar.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  // history: PropTypes.object.isRequired,
  isSidebarOpen: PropTypes.bool,
  onToggleSidebar: PropTypes.func,
  title: PropTypes.string
};

Topbar.defaultProps = {
  onToggleSidebar: () => {}
};

export default withStyles(styles)(Topbar);
